/**
 * Put your client code here.
 * It will be bundled and servered to the browser.
 */
console.log("Effect Start meets browser!")
